import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import './animation.css';
import './СomponentStyle.styl';
import '@vt/vt-ui/styles.css';
import 'react-notifications-component/dist/theme.css';
import '@vt/vt-ui/styles.css';

import store from './redux/store';
import { BrowserRouter } from 'react-router-dom';
import { ReactNotifications } from 'react-notifications-component';
import { AuthProvider } from './service/auth/JWTContext';
import Router from './routes';
import EnvHelper from './helpers/envHelper';

// Update PUBLIC_URL references in HTML head to use current domain
const envHelper = EnvHelper.getInstance();
const currentOrigin = envHelper.getPublicUrl();

// Update manifest link and other PUBLIC_URL references
if (typeof document !== 'undefined') {
  const manifestLink = document.querySelector('link[rel="manifest"]');
  if (manifestLink && manifestLink.getAttribute('href')) {
    const href = manifestLink.getAttribute('href');
    // If href contains a different origin, update it to current origin
    try {
      const url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin) {
        manifestLink.setAttribute('href', '/manifest.json');
      }
    } catch (e) {
      // If URL parsing fails, try to replace the origin
      if (href.includes('://')) {
        manifestLink.setAttribute('href', href.replace(/https?:\/\/[^/]+/, currentOrigin));
      } else {
        manifestLink.setAttribute('href', '/manifest.json');
      }
    }
  }

  // Update meta tags with PUBLIC_URL
  const metaTags = document.querySelectorAll('meta[property], link[rel="apple-touch-icon"]');
  metaTags.forEach((tag) => {
    const content = tag.getAttribute('content') || tag.getAttribute('href');
    if (content && content.includes('://')) {
      try {
        const url = new URL(content, window.location.href);
        if (url.origin !== window.location.origin) {
          const newContent = content.replace(/https?:\/\/[^/]+/, currentOrigin);
          if (tag.hasAttribute('content')) {
            tag.setAttribute('content', newContent);
          } else if (tag.hasAttribute('href')) {
            tag.setAttribute('href', newContent);
          }
        }
      } catch (e) {
        // Ignore parsing errors
      }
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
// rebuild
root.render(
  <div className="vt-dark App">
    <AuthProvider>
      <ReactNotifications />
      <Provider store={store}>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </Provider>
    </AuthProvider>
  </div>
);

// eslint-disable-next-line no-undef
if ('serviceWorker' in navigator) {
  // ใช้ได้ทั้งใน development และ production
  window.addEventListener('load', () => {
    const envHelper = EnvHelper.getInstance();
    const publicUrl = envHelper.getPublicUrl();
    const swUrl = `${publicUrl}/service-worker.js`;
    // eslint-disable-next-line no-undef
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        // ตรวจสอบการอัปเดต
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker == null) {
            return;
          }
          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed') {
              // eslint-disable-next-line no-undef
              if (navigator.serviceWorker.controller) {
                console.log(
                  'New content is available and will be used when all tabs for this page are closed.'
                );
                window.location.reload();
              } else {
                console.log('Content is cached for offline use.');
              }
            }
          };
        };
      })
      .catch((error) => {
        console.error('Error during service worker registration:', error);
      });
  });
}
